import { render, staticRenderFns } from "./ProjectAboutPure.vue?vue&type=template&id=49da1d28&scoped=true&"
import script from "./ProjectAboutPure.vue?vue&type=script&lang=ts&"
export * from "./ProjectAboutPure.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectAboutPure.vue?vue&type=style&index=0&id=49da1d28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49da1d28",
  null
  
)

export default component.exports